import React from 'react';
import './style.css';

const StoryReply = ({ story, isOwn }) => {
  if (!story) return null;

  const renderPreview = () => {
    if (story.type === 'image' && story.previewUrl) {
      return (
        <div className="story_reply_preview_image">
          <img 
            src={story.previewUrl.startsWith('http') ? story.previewUrl : `/uploads/stories/${story.previewUrl}`} 
            alt="Story preview"
          />
        </div>
      );
    } else if (story.type === 'video' && story.previewUrl) {
      return (
        <div className="story_reply_preview_video">
          <video src={story.previewUrl.startsWith('http') ? story.previewUrl : `/uploads/stories/${story.previewUrl}`} />
          <div className="play_icon">▶</div>
        </div>
      );
    } else if (story.text) {
      return (
        <div className="story_reply_preview_text">
          <p>{story.text.length > 60 ? `${story.text.substring(0, 60)}...` : story.text}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={`story_reply_container ${isOwn ? 'own' : ''}`}>
      <div className="story_reply_header">
        <span>Replied to {isOwn ? 'your vibe' : 'a vibe'}</span>
      </div>
      <div className="story_reply_content">
        {renderPreview()}
      </div>
    </div>
  );
};

export default StoryReply;
